import { render, staticRenderFns } from "./Header.vue?vue&type=template&id=741978ef&scoped=true&"
import script from "./Header.vue?vue&type=script&lang=js&"
export * from "./Header.vue?vue&type=script&lang=js&"
import style0 from "./Header.vue?vue&type=style&index=0&id=741978ef&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "741978ef",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/vhosts/owiwi.co.uk/staging.appraisal.owiwi.co.uk/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('741978ef', component.options)
    } else {
      api.reload('741978ef', component.options)
    }
    module.hot.accept("./Header.vue?vue&type=template&id=741978ef&scoped=true&", function () {
      api.rerender('741978ef', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Header/Header.vue"
export default component.exports